// extracted by mini-css-extract-plugin
export default {"item":"SideMenuItem_item__c+EWB"};